import $ from 'jquery'

$('.is-client').on('mouseenter', function () {
  let screenWidth = $(window).width()
  if (screenWidth >= 992) {
    $('.client-space-mouseover').css('display', 'flex').animate(
      {
        opacity: 1,
      },
      300
    )
  }
})

$('.client-space-mouseover').on('mouseleave', function () {
  let screenWidth = $(window).width()

  if (screenWidth >= 992) {
    $('.client-space-mouseover').animate(
      {
        opacity: 0,
      },
      300,
      function () {
        $(this).css('display', 'none')
      }
    )
  }
})

$('.is-client').on('click', function () {
  let screenWidth = $(window).width()

  if (screenWidth <= 992) {
    $('#client-space-modal').modal('show')
  }
})
